import React from "react";
import { Drawer, Box } from "@mantine/core";

interface DrawerLayoutProps {
  opened: boolean;
  onClose: () => void;
  title: React.ReactNode;
  content: React.ReactNode;
  bottom?: React.ReactNode;
  position?: "bottom" | "right" | "top" | "left";
}

const DrawerLayout: React.FC<DrawerLayoutProps> = ({
  opened,
  onClose,
  title,
  content,
  bottom,
  position = "right",
}) => {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      position={position}
      padding={0}
      sx={{
        width: "400px",
      }}
    >
      {/* Title */}
      {title}

      {/* Content */}
      <Box
        sx={{
          padding: "0 20px",
          gap: "24px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {content}
      </Box>

      {/* Bottom Section */}
      {bottom && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            padding: "16px",
            backgroundColor: "var(--mantine-color-white)",
            borderTop: "1px solid var(--mantine-color-gray-3)",
            zIndex: 100,
          }}
        >
          {bottom}
        </Box>
      )}
    </Drawer>
  );
};

export default DrawerLayout;
